import React from 'react';

export const CloseX: React.FC = () => (
  <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.335204 0.335205C-0.111735 0.782144 -0.111735 1.50678 0.335204 1.95372L4.38149 6.00001L0.335217 10.0463C-0.111722 10.4932 -0.111723 11.2179 0.335217 11.6648C0.782156 12.1117 1.50679 12.1117 1.95373 11.6648L6 7.61852L10.0463 11.6648C10.4932 12.1117 11.2178 12.1117 11.6648 11.6648C12.1117 11.2179 12.1117 10.4932 11.6648 10.0463L7.61851 6.00001L11.6648 1.95372C12.1117 1.50678 12.1117 0.782147 11.6648 0.335207C11.2179 -0.111733 10.4932 -0.111733 10.0463 0.335207L6 4.38149L1.95372 0.335205C1.50678 -0.111735 0.782144 -0.111735 0.335204 0.335205Z'
    />
  </svg>
);
